// extracted by mini-css-extract-plugin
export default {"label":"textareaInput_label__eHD7W","input":"textareaInput_input__Na3VI"};